/* eslint-disable vue/one-component-per-file */
import { createApp, h } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import { createMoneyRouter } from "@/router";
import "@/assets/main.scss";
import AmplifyConfig from "@/plugins/amplify/config.js";
import { apolloClient } from "@/api/client.js";
import { provideApolloClient } from "@vue/apollo-composable";
import AppLoadingPlaceholder from "@/components/AppLoadingPlaceholder.vue";
import VueClickOutsideElement from "vue-click-outside-element";
import MoneyWebappComponents from "@moroku/money-webapp-components";
import { config } from "@/config";
import MoneySentry from "@/plugins/sentry";
import { installPrimeVue } from "@/plugins/primevue";

function showLoadingPlaceholder() {
  return createApp({
    setup() {
      return () => h(AppLoadingPlaceholder);
    },
  });
}

async function initApp() {
  const app = createApp({
    setup() {
      provideApolloClient(apolloClient);
      return () => h(App);
    },
  });

  await MoneyWebappComponents.install(app, config.tenant);

  AmplifyConfig.configure();

  const router = createMoneyRouter();
  app.use(router);
  MoneySentry.configure(app, { router });

  app.use(createPinia());
  app.use(VueClickOutsideElement);

  installPrimeVue(app);

  return app;
}

const loadingApp = showLoadingPlaceholder();
loadingApp.mount("#app");

const mainApp = await initApp();
loadingApp.unmount();
mainApp.mount("#app");
